<template>
    <div id="news-iniziative" class="section news" v-if="this.dataLoaded">
        <div class="container">
            <h3>{{labelTitle}}</h3>
            <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" v-html="this.titlePage"></h1>
            <News :dataNews="this.dataNews"/>
        </div>
    </div>
</template>
<script>
import News from './News.vue';

export default {
  name: 'section-news',
    components:{
      News
  },
  props: {
      dataPages: {
          type: String
      },
      dataNews: {
          type: String
      }
  },
  data:()=>{
        return {
            titlePage:"News & Iniziative",
            idIntroPage:"4f5d56da-0d43-4098-bfc2-696010d632c7",
            page:[],
            dataLoaded:false
        }
  },
  computed:{
            labelTitle(){
                let label;
                if(this.$route.params.lang == "it"){
                    label = "Ultimi aggiornamenti"
                } else {
                    label = "LATEST FROM US"
                }
                return label
            }
        },
methods:{
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.news {
    overflow: hidden;
    background: #E3E3E3;
    height: auto;
    h3 {
        color: #fff;
    }
  
}
</style>
